module.exports = __webpack_public_path__ + "img/coin_gray.70244896.svg";